// extracted by mini-css-extract-plugin
module.exports = {"recall":"efdelta-discharge-information_recall__vD7Hf"};